import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../../store/store-keys'
import { IHeaderState } from './header.reducers'
import cloneDeep from 'lodash/cloneDeep'

export const selectHeaderComponent =
    createFeatureSelector<Readonly<IHeaderState>>(StoreKeysEnum.HeaderComponent)

export const selectHeaderComponentByKey = (key: string): MemoizedSelector<IHeaderState, any> => createSelector(
    selectHeaderComponent,
    (headerState): IHeaderState => {
        return headerState?.[key]
    }
)

export const selectHeaderFilterCriteria = (key: string): MemoizedSelector<IHeaderState, any> => createSelector(
    selectHeaderComponentByKey(key),
    (data) => ({ ...data?.filterCriteria })
)

export const selectItemCollection = (key: string): MemoizedSelector<IHeaderState, any> => createSelector(
    selectHeaderComponentByKey(key),
    (data) => cloneDeep(data?.itemCollection)
)

export const selectHeaderData = (key: string): MemoizedSelector<IHeaderState, any> => createSelector(
    selectHeaderFilterCriteria(key),
    selectItemCollection(key),
    (filterCriteria, itemCollection) => ({
        filterCriteria: filterCriteria || {},
        itemCollection: itemCollection || []
    })
)